import { Icon, IconProps } from '@chakra-ui/react';
import { ReactElement } from 'react';

export const ArticleVideoIcon = (props: IconProps): ReactElement => {
  return (
    <Icon {...props}>
      <svg viewBox="0 0 24 24">
        <g clipPath="url(#clip0_13444_4642)">
          <rect
            x="1.75"
            y="3.75"
            width="20.5"
            height="16.5"
            rx="1.25"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M15.9105 11.7634C16.1098 11.8799 16.1082 12.1685 15.9075 12.283L9.44337 15.9694C9.24272 16.0838 8.99354 15.9382 8.99485 15.7073L9.03697 8.26742C9.03828 8.03648 9.28909 7.89345 9.48843 8.00995L15.9105 11.7634Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
          />
        </g>
        <defs>
          <clipPath id="clip0_13444_4642">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};
